import { FETCH_ORGANISATIONS } from '../actions/organisations';

const initialState = {
  fetching: false,
  data: []
}
const organisations = (state = initialState, action) => {
  switch(action.type) {
    case `${FETCH_ORGANISATIONS}_PENDING`:
      return { ...state, fetching: true }
    case `${FETCH_ORGANISATIONS}_FULFILLED`:
      return { fetching: false, data: action.payload }
    default:
      return state;
  }
}

export default organisations;



// WEBPACK FOOTER //
// ./src/reducers/organisations.js